import {Component, forwardRef, Input, Optional} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DescriptionStrategy, Image as GalleryImage} from '@ks89/angular-modal-gallery';
import {NbinputConfig} from './nbinput.entity';

@Component({
  selector: 'nbinput-gallery',
  template: require('./nbinput-gallery.component.html'),
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputGalleryComponent),
      multi: true
    }
  ]
})

export class NbinputGalleryComponent implements ControlValueAccessor {
  registerOnChange(fn: any): void {/* gallery不支持用户手动修改值 */}
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {/* gallery没有禁用与否的区别 */}
  writeValue(obj: string): void {
    setTimeout(() => {
      this.data = obj;
    }, 0);
  }

  public rid: string = 'nbg-' + Math.random() * 10000000;
  public imgConf = {
    downloadable: false,
    description: {
      strategy: DescriptionStrategy.ALWAYS_VISIBLE,
      style: { marginBottom: '0px' }
    }
  };

  @Input()
  config: NbinputConfig = new NbinputConfig();

  _data;
  @Input()
  set data(val: any) {
    this.imgs = [];
    this._data = val;
    // 1. 如果 val 不是 array
    // 1.1 如果 val 是 string of URL
    // 1.2 如果 val 是 Attachment
    if (!!val) {
      if (typeof val == 'object' && typeof val.length == 'number') {
        this.imgs = val.filter(e => !!e && (((typeof e == 'string') && e.length > 0) || e.url && e.url.length > 0)).map((e, i) =>
          (typeof e == 'string') ?
            new GalleryImage(i + 1, {
              img: '' + (e.startsWith('http:') || e.startsWith('https:') ? '' : this.config.downloadAPI) +
              e + (this.config.token && this.config.token.length > 0 ? '' : '?token=' + this.config.token)
            })
            : new GalleryImage(i + 1, {
              img: (e.url.startsWith('http:') || e.url.startsWith('https:') ? '' : this.config.downloadAPI) +
              e.url + (this.config.token && this.config.token.length > 0 ? '' : '?token=' + this.config.token),
              title: e.name,
              alt: e.name
            }));
      } else if (typeof val == 'string' && val.length > 0) {
        this.imgs = [
          new GalleryImage(1, {
            img: '' + (val.startsWith('http:') || val.startsWith('https:') ? '' : this.config.downloadAPI) +
            val + (this.config.token && this.config.token.length > 0 ? '' : '?token=' + this.config.token)
          })];
      } else if (val.url && val.url.length > 0) {
        this.imgs = [
          new GalleryImage(1, {
            img: (val.url.startsWith('http:') || val.url.startsWith('https:') ? '' : this.config.downloadAPI) +
            val.url + (this.config.token && this.config.token.length > 0 ? '' : '?token=' + this.config.token),
            title: val.name,
            alt: val.name
          })];
      }
    }
  }
  get data() {
    return this._data;
  }
  imgs;
  constructor(
  ) {}
}

